import React, {
  forwardRef,
  isValidElement,
  cloneElement,
  ForwardedRef
} from "react";
import {ButtonCustomType} from "./types";
import {getCssClasses} from "./utils";

export const SVVButtonCustom = forwardRef<(HTMLButtonElement | HTMLAnchorElement), ButtonCustomType>(
  function ButtonInternal(
    props: ButtonCustomType,
    ref: ForwardedRef<HTMLButtonElement | HTMLAnchorElement>
  ) {
    const {
      children,
      loading,
      icon,
      loadingString,
      // Fjern buttonType fra restProps for å unngå å rendre denne i DOM-en
      // når vi spreader rest til <Element>
      // eslint-disable-next-line
      asElement,
      hrefAttribute,
      // Fjern boolske props fra restProps. React gir en warning hvis disse sendes
      // til <button> vha {...restProps}
      // eslint-disable-next-line
      small,
      // eslint-disable-next-line
      looksLikeLink,
      // eslint-disable-next-line
      iconPlacement,
      // eslint-disable-next-line
      color,
      ...restProps
    } = props;

    const Element = asElement;

    return (
      <Element
        ref={ref}
        {...(hrefAttribute && props.href && { [hrefAttribute]: props.href })}
        {...restProps}
        className={getCssClasses(props)}
      >
        {icon && isValidElement(icon) && cloneElement(icon, {"aria-hidden": true})}
        <span aria-live="assertive" className="svv-button--loading-span">
        {loading ? `${loadingString}` : ""}
        </span>
        {children}
      </Element>
    );
  }
);

SVVButtonCustom.displayName = "SVVButtonCustom";
